module.exports = __webpack_public_path__ + "img/kleisma1-m@1.0eefb8e1.webp";